import { Link } from "@tanstack/react-router";

import CloudinaryImage from "@/components/cloudinary-image";
import { gameUrl } from "@/helpers/games";

import type { GameType } from "./types";

interface GameDetailsProps {
  game: GameType;
}

export default function GameDetails({ game }: GameDetailsProps) {
  return (
    <div className="relative flex items-center gap-2.5 rounded-[10px] border border-white/10 p-2.5 transition-colors hover:bg-white/5">
      <CloudinaryImage className="size-10 rounded-[3px]" game={game} rW={80} />
      <div className="flex flex-col items-start">
        <h2 className="font-medium text-13/[1.5em] text-white">
          <Link className="link-overlay" to={gameUrl(game)}>
            {game.name}
          </Link>
        </h2>
        <h3 className="font-medium text-12 text-white/80">
          {game.location.displayName || game.location.company.name}
        </h3>
      </div>
    </div>
  );
}
